exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LoadableCentered-dfd3e40f{text-align:center;padding:40px}\n", ""]);

// Exports
exports.locals = {
	"LoadableCentered": "LoadableCentered-dfd3e40f"
};